export class TeamMember {
    isSelf: boolean;
    userId: number;
    jobUserTypeId: number;
    createTimestamp: number;
    teamName: string;
    candidatesAwaitingFeedbackCount: number;
    fullName: string;
    email: string;
}
